'use client';

import { HStack } from '@terra/ui-styled-system';
import { ArrowDown01Icon, ArrowUp01Icon } from '@terra/ui-icons';
import { Button } from '../../components/button';
import { BodyStrong } from '../../components/typography';
import { MfaRefreshIconButton } from './MfaRefreshIconButton';
import type { IconButtonSize } from '../../components/icon-button';

export type MfaMessagesToggleHeaderProps = {
  title: string;
  isExpanded: boolean;
  onToggle: () => void;
  toggleAriaLabel: string;
  toggleLoading?: boolean;
  toggleDisabled?: boolean;
  buttonSize?: 'xs' | 'sm';
  iconSize?: number;
  refreshLabel?: string;
  onRefresh?: () => void;
  refreshLoading?: boolean;
  refreshDisabled?: boolean;
  refreshButtonSize?: IconButtonSize;
};

export function MfaMessagesToggleHeader({
  title,
  isExpanded,
  onToggle,
  toggleAriaLabel,
  toggleLoading = false,
  toggleDisabled = false,
  buttonSize = 'xs',
  iconSize = 14,
  refreshLabel,
  onRefresh,
  refreshLoading = false,
  refreshDisabled = false,
  refreshButtonSize = 'xs',
}: MfaMessagesToggleHeaderProps) {
  const showRefresh = isExpanded && refreshLabel && onRefresh !== undefined;

  return (
    <HStack justifyContent="space-between" alignItems="center">
      <Button
        variant="ghost"
        size={buttonSize}
        alignSelf="flex-start"
        justifyContent="flex-start"
        px={0}
        onClick={onToggle}
        loading={toggleLoading}
        disabled={toggleDisabled}
        aria-label={toggleAriaLabel}
      >
        <HStack gap={2} alignItems="center">
          <BodyStrong color="fg.default">{title}</BodyStrong>
          {isExpanded ? (
            <ArrowUp01Icon size={iconSize} />
          ) : (
            <ArrowDown01Icon size={iconSize} />
          )}
        </HStack>
      </Button>
      {showRefresh ? (
        <MfaRefreshIconButton
          label={refreshLabel}
          onClick={onRefresh}
          isLoading={refreshLoading}
          disabled={refreshDisabled}
          size={refreshButtonSize}
        />
      ) : null}
    </HStack>
  );
}
